module.exports = __webpack_public_path__ + "static/media/calendar_month.66a71235.svg";